module.exports = __webpack_public_path__ + "img/16-4.f5f75832.png";